import React from 'react';
import PropTypes from 'prop-types';
import css from '@src/styles/components/card.scss';

export default class Card extends React.Component {

    static get propTypes() {

        return {
            isDefault: PropTypes.bool,
            children: PropTypes.any,
            className: PropTypes.string,
            bodyClassName: PropTypes.string,
        };
    }

    render() {

        const classes = [css.card];
        
        if (this.props.isDefault)
            classes.push(css['card--default']);

        if (this.props.className != undefined)
            classes.push(this.props.className);


        const bodyClasses = [css['card__body']];
        if (this.props.bodyClassName != undefined)
            bodyClasses.push(this.props.bodyClassName);

        return (
            <div className={ classes.join(' ') }>
                <div className={ bodyClasses.join(' ') }>{ this.props.children }</div>
            </div>
        );
    }

}